/**
 * WebhookReprocessarResponse
 * @author Thacryba
 */
import {$, Helper, Model, Request} from 'simpli-web-sdk'

export class WebhookReprocessarResponse extends Model {
  linhasReprocessadas: number[] | null = null
  linhasJaForamProcessadas: number[] | null = null
  linhasNaoExistentes: number[] | null = null
  linhasNaFila: number[] | null = null
}
